"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _text = require("@mmc/text");

var _commonOptionCard = require("@mmc/common-option-card");

var _commonI18n = require("@mmc/common-i18n");

var _reactRedux = require("react-redux");

var _commonRichText = require("@mmc/common-rich-text");

var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _configuratorAccessoriesSelector = _interopRequireDefault(require("../styles/configurator-accessories-selector.css"));

var _configuratorAccessoriesSelector2 = _interopRequireDefault(require("./configurator-accessories-selector.props/configurator-accessories-selector.propTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
    appendImageOptimization = dataUtils.appendImageOptimization;

var CardWrapper = function CardWrapper(_ref) {
  var filterPackage = _ref.filterPackage,
      theme = _ref.theme,
      config = _ref.config,
      changeEvent = _ref.changeEvent,
      selectedAccessories = _ref.selectedAccessories,
      forcedOptionCodes = _ref.forcedOptionCodes,
      notCompatibleOptionCodes = _ref.notCompatibleOptionCodes,
      addPriceDisclaimer = _ref.addPriceDisclaimer,
      priceDisclaimerId = _ref.priceDisclaimerId,
      disclaimerData = _ref.disclaimerData;
  var description = handleNestedProp(filterPackage, 'filterPackage.titleAndText.text');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorAccessoriesSelector["default"].accessorySelectorCardContainer
  }, /*#__PURE__*/_react["default"].createElement(_commonOptionCard.CommonOptionCard, {
    theme: theme,
    name: "accessory-" + filterPackage.type,
    value: filterPackage.code,
    label: filterPackage.label,
    fullTap: true,
    type: "checkbox",
    isSelected: selectedAccessories.includes(filterPackage.code),
    disabled: forcedOptionCodes.includes(filterPackage.code) || notCompatibleOptionCodes.includes(filterPackage.code),
    onChange: changeEvent
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorAccessoriesSelector["default"].cardText
  }, filterPackage.price && /*#__PURE__*/_react["default"].createElement("p", {
    className: _configuratorAccessoriesSelector["default"].accessoryPrice + " " + theme.bodyCopy
  }, filterPackage.price.value !== undefined && handleNestedProp(filterPackage, 'filterPackage.price.label'), /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    returnZero: true,
    options: {
      value: handleNestedProp(filterPackage, 'filterPackage.price.value'),
      currency: handleNestedProp(config, 'config.currencyFormat'),
      locale: handleNestedProp(config, 'config.localeCode')
    },
    addPriceDisclaimer: Boolean(priceDisclaimerId),
    priceDisclaimerId: priceDisclaimerId,
    disclaimerData: disclaimerData
  })), /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    className: _configuratorAccessoriesSelector["default"].cardTextImage + " " + _configuratorAccessoriesSelector["default"].fullHeightImage,
    src: appendImageOptimization(handleNestedProp(filterPackage, 'filterPackage.image.image'), 600, undefined, undefined, 70) // eslint-disable-line
    ,
    alt: handleNestedProp(filterPackage, 'filterPackage.image.altText')
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: _configuratorAccessoriesSelector["default"].accessoryDescription + " " + theme.bodyCopy,
    text: description !== ' ' && /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      html: description
    }),
    tag: "div",
    disclaimerData: disclaimerData
  })))));
};

CardWrapper.displayName = 'CardWrapper';
CardWrapper.defaultProps = {
  config: {}
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(CardWrapper);

exports["default"] = _default;